import { useState } from 'react';

export interface LogInStatus {
  username: string | null;
  accesses: string[];
  isEcommerceOperator?: boolean;
  isAdmin?: boolean;
}

// 从 localstorage 获取登录状态
export const getInitLoginStatus = () => {
  const username = localStorage.getItem('username');
  const accesses = localStorage.getItem('accesses') || '[]';

  const initialData = username
    ? {
        username,
        accesses: JSON.parse(accesses),
      }
    : {
        username: null,
        accesses: [],
      };
  return initialData;
};

export const useLogin = () => {
  const [data, setData] = useState<LogInStatus>(getInitLoginStatus);
  const { username } = data;
  const isEcommerceOperator = username?.includes('evan');
  const isAdmin = ['evan', 'sandy', 'admin'].some((name) =>
    username?.includes(name)
  );

  return [{ ...data, isEcommerceOperator, isAdmin }, setData] as const;
};
